import React, {Component} from 'react';
import './TheTeam.css';
import midori from '../../../images/MidoriAw.png';
import william from '../../../images/WilliamLau.png';
import TeamCard from './TeamCard.js';

export default class TheTeam extends Component {

	render() {

		return (
			<div className="the_team_container" id="TheTeam">
				<div className="the_team_title">
					<span>KEY MEMBERS</span>
				</div>
				<div className="the_team_content">
					<TeamCard
						name="Ms Midori Aw"
						title="Executive Director"
						description="Ms Aw’s key role includes identifying potential business opportunities for developments finding new business investment opportunities nearby developing countries such as Cambodia, Myanmar, Vietnam and Indonesia."
						description2="With her knowledge & experience she defines investment criteria, evaluates business proposal and conducts feasibility studies on all prospective investment prospects. Likewise, she is also involved in the planning, development and marketing of the proposed development."
						description3="Under Midori’s guidance and vision, PPI continues to build an impressive portfolio into various industries and currently invested into Healthcare Provider in the United Kingdom."
						lastPosition="Managing Director - Macquarie Holdings Pte Ltd"
						lastPosition2="Director - Aries Property Group, United Kingdom"
						lastPosition3="Director - Aries Healthcare Group, United Kingdom"
						image={midori}
					/>
					<TeamCard
						name="Mr William Lau"
						title="Lead Advisor"
						description="As the business advisor of Pacific Prince International Pte Ltd, Mr Lau advises the company direction and actively initiates project development to support new businesses start up, and established businesses grow. A positive thinker with emphasis on providing information & advice as platform for successful partnership to deliver quality investment for client."
						description2="Mr Lau provide advice in full value chain of Real Estate development, from pre-acquisition analysis to feasibility studies, marketing contract review and negotiation for Joint Venture for Foreign Direct Investment."
						description3="With his professional experience, PPI was recognized for bringing an integrated environmental approach to building innovation, saving time and scarce resources for the development project."
						lastPosition="Ambassador for South East Asia - Int’l Federation for Housing and Planning (IFHP)"
						lastPosition2="President (2010 to 2014) - Singapore Institute of Planners (SIP)"
						lastPosition3="Adjunct Senior Fellow - Singapore University of Technology & Design (SUTD) Academy"
						lastPosition4="Founder & Principal - A.Alliance Design International Architects & Planners (AADI)"
						lastPosition5="Chairman - Aries Property Group, United Kingdom"
						lastPosition6="Chairman - Aries Healthcare Group, United Kingdom"
						lastPosition7="Chairman - One Singapore Town Private Limited "
						image={william}
					/>
				</div>
			</div>
		)
	}
};
